export const calculateGiftCardCart = (params: {
  discountAmount: number;
  giftCardAmount: number;
  quantity: number;
}) => {
  const { discountAmount, giftCardAmount, quantity } = params;

  const subtotal = quantity * giftCardAmount;
  const total = subtotal - discountAmount;

  return {
    total,
    subtotal
  };
};
